// extracted by mini-css-extract-plugin
export var equalColumn = "_ey-0";